import buildFormatLongFn from '../../../_lib/buildFormatLongFn/index'

var dateFormats = {
  "full": "y MMMM d, EEEE",
  "long": "y MMMM d",
  "medium": "y MMM d",
  "short": "y-MM-dd",
}

var timeFormats = {
  "full": "HH:mm:ss zzzz",
  "long": "HH:mm:ss z",
  "medium": "HH:mm:ss",
  "short": "HH:mm",
}

var dateTimeFormats = {
  "full": "{{date}} {{time}}",
  "long": "{{date}} {{time}}",
  "medium": "{{date}} {{time}}",
  "short": "{{date}} {{time}}",
}

var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
}

export default formatLong
